import { ANALYTICS_API_GATEWAY_URL } from '../../API/BaseUrls';

function AwsApi(core) {
    this.client = core.client;
}

Object.assign(AwsApi.prototype, {
    namespace: 'AwsApi',
    sendToFirehose(data) {
        return this.client.send('POST', `${ANALYTICS_API_GATEWAY_URL}/v1/wizyconf`, data, {}, undefined, false);
    }
});

export default AwsApi;
